import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { AngularFireAuth } from 'angularfire2/auth';
// import * as firebase from 'firebase/app';

import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { AuthPageManageService } from '../manage/page-manage/auth-page-manage.service';
import { ToolsService } from '../tools/tools.service';
import { LangagesService } from '../manage/langages/langages.service';
import { MyStripeService } from '../apiclient/myStripe/my-stripe.service';

/////////////////////////////////////////
import { ClientaddressesService } from '../apiclient/clientaddresses/clientaddresses.service';
import { SmsnotificationsService } from '../apiclient/smsnotifications/smsnotifications.service';
import { ClientaccountService } from '../apiclient/clientaccount/clientaccount.service';
import { ResponseService } from '../manage/response/response.service';

//new
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { PanierService } from '../manage/panier/panier.service';
import { TranslateService } from '@ngx-translate/core';
import {SalemethodService} from "../api/salemethod/salemethod.service";

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  // Erreur actuelle
  private error: Subject<any> = new BehaviorSubject(null);

  // Utilisateur actuel
  private user: BehaviorSubject<any> = new BehaviorSubject(null);

  // Clé sms correspondant à une sms notif
  private smsKey$: any;

  /**
   * @description Retourne l'erreur actuelle
   * @return {Observable}
   */
  get getError(): Observable<string> {
    return this.error.asObservable();
  }
  /**
  * @description Retourne l'erreur actuelle
  * @return {Observable}
  */
  setError(data: any) {
    this.error.next(data);
  }

  /**
   * @description Retourne l'utilisateur actuel
   * @return {Observable}
   */
  get getUser(): Observable<any> {
    return this.user.asObservable();
  }

  // Firebase providers (Twitter, facebook et google)
  private twitterProvider = new firebase.auth.TwitterAuthProvider();
  private facebookProvider = new firebase.auth.FacebookAuthProvider();
  private googleProvider = new firebase.auth.GoogleAuthProvider();

  // Provider firbase actuel
  public currentProvider: any;

  // Provider utilisé après une erreur
  // Exemple: Si utilisateur déjà inscrit avec Google avec meme mail que facebook -> Si utilisateur se connecte avec facebook le provider sera donc google après erreur.
  public afterErrProvider: any;

  constructor(
    private af: AngularFireAuth,
    private router: Router,
    private authPageServ: AuthPageManageService,
    private tools: ToolsService,
    private addressApi: ClientaddressesService,
    private clientApi: ClientaccountService,
    private langService: LangagesService,
    private myStripe: MyStripeService,
    private smsApi: SmsnotificationsService,
    private responseServ: ResponseService,
    private panierMan: PanierService,
    public translate: TranslateService
  ) {
    this.getSmsKey();
  }

  /**
   * @description Récupère la clé sms si il y en a une.
   * @return {void}
   */
  getSmsKey(): void {
    this.authPageServ.getSmsKey().subscribe(smsKeyData => {
      if (smsKeyData) {
        this.smsKey$ = smsKeyData.unique_id;
      }
    });
  }






  // AngularFireAuth.authState.pipe(first()).toPromise();
  /**
   * @description Connecte ou crée un compte via un compte  facebook | twitter | google
   * @param {string} provider Le nom du provider firebase à utiliser (Ex: facebook)
   * @param {string} phone Numéro de téléphone
   * @param {string} firstname Prénom
   * @param {string} lastname Nom de famille
   * @return {void}
   */


  signInWithCredential(provider: string | any, phone?: string | any, countryId?: number | any, firstname?: string | any, lastname?: string | any, birth?: string | any, enable_marketing?: number | any): Promise<any> {



    const that = this;

    // Récupréation du provider via son
    const currProvider = that.getProvider(provider);


    // Provider actuel
    that.currentProvider = provider;


    // Réinitialisation des erreurs
    that.error.next(null);

    return new Promise(function (resolve, reject) {
      // that.af.auth.signInWithPopup(currProvider).then(function (result:any) {


      that.af.signInWithPopup(currProvider).then(function (result: any) {


        let isNewUser: any = result.additionalUserInfo.isNewUser;



        // Si c'est un nouvel utilisateur et qu'il a besoin de passer par un code sms et qu'il n'y en a pas
        if (isNewUser && !that.smsApi.conditionSms()) {

          // Suppression du compte firebase qui vient juste d'être créé + affichage de l'erreur

          // that.af.currentUser.delete().then(function () {
          // (that.af.currentUser).delete().then(function () {
          //   that.error.next("noregister");
          //   reject();
          // });

          that.af.currentUser.then(function (user: any) {
            user.delete().then(function (val: any) {

              that.error.next("noregister");
              reject();
            });
          })

        } else {

          if (that.smsKey$) {

            if (isNewUser) {


              // Vérif des informations requises avant de continuer
              if (!firstname || !lastname || !phone) {

                // Supprime le compte firebase qui vient d'être créé
                // that.af.auth.currentUser.delete().then(function () {

                //   // Set l'erreur
                //   that.error.next("credentialinfomissing");

                //   // Redirige vers le composant register si jamais l'erreur est survenue sur le composant login
                //   that.authPageServ.setCurrPage("register");

                //   // Reject de la promise
                //   reject({ error: "credentialinfomissing", user_info: result.additionalUserInfo.profile });

                // });


                that.af.currentUser.then(function (user: any) {

                  user.delete().then(function (val: any) {

                    // Set l'erreur
                    that.error.next("credentialinfomissing");

                    // Redirige vers le composant register si jamais l'erreur est survenue sur le composant login
                    that.authPageServ.setCurrPage("register");

                    // Reject de la promise
                    reject({ error: "credentialinfomissing", user_info: result.additionalUserInfo.profile });
                  });
                })



              } else {

                that.smsApi.closeSmsNotification(that.smsKey$, firstname, lastname).then(data => {

                  if (data.code === 0) {

                    resolve(null);

                  } else {

                    if (isNewUser) {

                      that.handleApiError(data.code);
                      that.deleteFbUser();

                    } else {
                      // that.af.auth.signOut();
                      that.af.signOut();

                    }

                    that.tools.openSnackBar(that.responseServ.getErrorMessage(data.code), "warn", 5000);

                    reject();

                  }

                }).catch(err => {


                  if (isNewUser) {

                    // that.af.auth.currentUser.delete().then(function () {
                    //   that.handleApiError(500);
                    //   reject();
                    // });


                    that.af.currentUser.then(function (user: any) {
                      user.delete().then(function (val: any) {

                        that.handleApiError(500);
                        reject();
                      });
                    })



                  }

                  else {

                    that.handleApiError(500);
                    // that.af.auth.signOut();
                    that.af.signOut();
                    reject();

                  }

                });

              }

            } else {

              that.smsApi.closeSmsNotification(that.smsKey$, firstname, lastname).then(data => {

                if (data.code === 0) {

                  that.updateLastLogin().then(data => {

                    if (data.code === 0) {

                      resolve(null);

                    }

                  })

                } else {
                  // that.af.auth.signOut();
                  that.af.signOut();

                  that.tools.openSnackBar(that.responseServ.getErrorMessage(data.code), "warn", 5000);
                  reject();

                }

              }).catch((err: any) => {

                if (isNewUser) {

                  // that.af.auth.currentUser.delete().then(function () {
                  //   that.handleApiError(500);
                  //   reject();
                  // });

                  that.af.currentUser.then(function (user: any) {

                    user.delete().then(function (val: any) {

                      that.handleApiError(500);
                      reject();
                    });
                  })

                }

                else {

                  that.handleApiError(500);
                  // that.af.auth.signOut();
                  that.af.signOut();
                  reject();

                }

              });

            }


          } else {

            if (isNewUser) {

              // Vérif des informations requises avant de continuer
              if (!firstname || !lastname || !phone) {

                // Supprime le compte firebase qui vient d'être créé
                // that.af.auth.currentUser.delete().then(function () {

                //   // Set l'erreur
                //   that.error.next("credentialinfomissing");

                //   // Redirige vers le composant register si jamais l'erreur est survenue sur le composant login
                //   that.authPageServ.setCurrPage("register");

                //   // Reject de la promise
                //   reject({ error: "credentialinfomissing", user_info: result.additionalUserInfo.profile });

                // });

                // Supprime le compte firebase qui vient d'être créé
                that.af.currentUser.then(function (user: any) {

                  user.delete().then(function (val: any) {

                    // Set l'erreur
                    that.error.next("credentialinfomissing");

                    // Redirige vers le composant register si jamais l'erreur est survenue sur le composant login
                    that.authPageServ.setCurrPage("register");

                    // Reject de la promise
                    reject({ error: "credentialinfomissing", user_info: result.additionalUserInfo.profile });
                  });
                })

              } else {

                that.createClient(phone, countryId, firstname, lastname, enable_marketing).then(data => {


                  resolve(null);

                }).catch(err => {

                  reject({ error: "createclient" });

                });

              }


            } else {

              that.updateLastLogin().then(data => {

                if (data.code === 0) {

                  resolve(null);

                }

              })

            }

          }

        }

      }).catch(function (error: any) {


        if (error.code === 'auth/account-exists-with-different-credential') {

          const email = error.email;

          // that.af.auth.fetchSignInMethodsForEmail(email).then(function (methods:any) {
          that.af.fetchSignInMethodsForEmail(email).then(function (methods: any) {

            that.afterErrProvider = methods[0];

            if (methods[0] === 'password') {

              that.error.next('emailpass');
              reject({ error: "emailpass", email: email });

            } else {

              reject({ error: "credential" });

            }

          });

        }

      });

    });

  }

  /**
   * @description Crée un compte via un formulaire d'inscription
   * @param {string} email
   * @param {string} password
   * @param {string} phone
   * @param {string} firstname
   * @param {string} lastname
   * @return {Promise}
   */
  registerEmailPass(email: string, password: string, phone: string, countryId: number, firstname: string, lastname: string, enable_marketing: number, society?: any): Promise<any> {

    const that = this;

    return new Promise((resolve, reject) => {

      // that.af.auth.createUserWithEmailAndPassword(email, password).then(function (result:any) {
      that.af.createUserWithEmailAndPassword(email, password).then(function (result: any) {


        if (that.smsKey$) {

          that.smsApi.closeSmsNotification(that.smsKey$, firstname, lastname).then(data => {

            if (data.code === 0) {

              that.tools.setStatusMessage(that.translate.instant('mailconfirm') + email);
              resolve(null);

            } else {

              that.handleApiError(data.code);
              that.deleteFbUser();
              reject();

            }

          }).catch(err => {

            that.handleApiError(500);
            that.deleteFbUser();
            reject();

          });

        } else {

          that.createClient(phone, countryId, firstname, lastname, enable_marketing, society).then(() => {

            resolve(null);

          }).catch(err => {

            reject();

          });

        }

      }).catch(function (error: any) {

        if (error.code === 'auth/email-already-in-use') {
          that.error.next('erremailalreadyuse');
        } else {
          that.handleApiError(500);
        }

        reject();

      });
    });

  }

  /**
   * @description Connecte un compte via formulaire d'identification
   * @param {string} email
   * @param {string} password
   * @return {Promise}
   */
  signInEmailPass(email: string, password: string): Promise<any> {
    const that = this;

    return new Promise(resolve => {

      // that.af.signInWithEmailAndPassword(email, password).then(function (result:any) {
      that.af.signInWithEmailAndPassword(email, password).then(function (result: any) {

        if (that.smsKey$) {

          that.smsApi.closeSmsNotification(that.smsKey$).then(data => {

            if (data.code < 0) {

              that.handleApiError(data.code);
              that.tools.openSnackBar(that.responseServ.getErrorMessage(data.code), "warn", 5000);

            } else {

              that.updateLastLogin().then(data => {


                if (data.code === 0) {

                  resolve(null);

                }

              })

            }

          }).catch(err => {

            that.handleApiError(500);

          });

        } else {

          that.updateLastLogin().then(data => {



            if (data.code === 0) {

              resolve(null);

            }

          })

        }

      }).catch(function (error: any) {

        if (error.code === 'auth/wrong-password') {

          that.error.next('password');

        } else if (error.code === 'auth/user-not-found') {

          that.error.next('user');

        } else {

          that.handleApiError(500);

        }

        resolve(null);

      });
    });
  }


  /**
   * @deprecated N'est plus utilisé pour le moment
   * @description Envoie un mail de vérification à l'utilisateur actuel
   * @return {Promise}
   */
  verifMail(): Promise<any> {

    const that = this;

    // const actionCodeSettings = {
    //   // url: 'https://localhost:4200/?email=' + that.af.auth.currentUser.email,
    //   url: 'https://localhost:4200/?email=' + that.af.currentUser,

    // };


    // that.af.auth.languageCode = this.langService.getLang();

    that.af.languageCode = new Promise(() => this.langService.getLang());

    that.error.next(null);

    return new Promise((resolve, reject) => {

      // that.af.auth.currentUser.sendEmailVerification(actionCodeSettings).then(function () {
      //   resolve(null);
      // }).catch(function (error: any) {
      //   that.handleApiError(500);
      //   reject(error);
      // });

      // that.af.currentUser.then(function (currentUser: any) {


      that.af.currentUser.then(function (currentUser: any) {
        let actionCodeSettings: any = {
          url: 'https://localhost:4200/?email=' + currentUser,
        };
        currentUser.sendEmailVerification(actionCodeSettings).then(function () {
          resolve(null);
        }).catch(function (error: any) {
          that.handleApiError(500);
          reject(error);
        });
      })





    });

  }

  /**
   * @description Envoie un mail de réinitialisation de mot de passe
   * @param {string} email Adresse mail cible
   * @return {Promise}
   */
  forgotPassMail(email: string): Promise<any> {
    const that = this;
    that.error.next(null);

    return new Promise(function (resolve) {

      // that.af.auth.sendPasswordResetEmail(email).then(function () {
      that.af.sendPasswordResetEmail(email).then(function () {

        that.error.next("sended");
        resolve(null);

      }).catch(function (error: any) {

        if (error.code === 'auth/user-not-found') {
          that.error.next('forgMail');
        } else if (error.code === 'auth/internal-error') {
          that.error.next('request');
        } else {
          that.handleApiError(500);
        }

        resolve(null);

      });
    });
  }

  /**
   * @description Check si l'utilisateur est toujours connecté et effectue des actions en fonction.
   * @return {Promise} User | null
   */
  checkIfAuth(intentconnect?: any): Promise<any> {
    const that = this;
    return new Promise(function (resolve, reject) {

      let currSM: any = that.tools.getStor(SalemethodService.TAG_STORAGE);

      // Trigger authentification Firebase
      that.af.onAuthStateChanged(function (user: any) {

        // Un utilisateur est connecté
        if (user) {

          // Set l'utilisateur actuel
          that.user.next(user.providerData[0]);

          // Set la clé stripe en fonction de l'utilisateur
          that.myStripe.setKeyByUser(user.uid);

          // Retourne l'utilistateur actuel
          resolve(user);
        }

        else {

          // Mode commande à table, pas d'authentification requise sur certains modes de vente
          // Set utilisateur system fulle uid
          if (currSM && currSM.disable_authentification && !intentconnect) {
            //TODO voir si obligatoire ?
            that.myStripe.setKeyByUser("gkJd5psm6ZfEs6lK1LSEVFv3RJj2");
            resolve("user");
          }

          // Unset l'utilisteur actuel
          that.user.next(null);

          // Reject la promise
          reject();
        }
      });
    });
  }

  /**
   * @description Dédconnecte un utilisateur et le redirige si besoin
   * @param redirectUrl Url de redirection (optionnel)
   * @return {void}
   */
  logOut(redirectUrl?: any, provenance?: any): void {
    const that = this;
    // that.af.auth.signOut().then(function () {
    that.af.signOut().then(function () {
      that.user.next(null);
      that.addressApi.removeBillingAddress();
      that.addressApi.removeDelivryAddress();
      that.myStripe.removeCurrCard();
      let flag = true;
      if (provenance && that.tools.checkCurrentPage('endorder') || that.tools.checkCurrentPage("product")) {
        let basket = that.tools.getStor(PanierService.TAG_STORAGE) ? that.tools.getStor(PanierService.TAG_STORAGE) : null;
        if (basket) {
          flag = false;
        }
      }

      if (flag) {
        that.tools.removeStor("info_notes");
        that.tools.removeStor("date_order");
        that.tools.removeStor("hour_order");
      }

      if (redirectUrl) {
        that.router.navigate([redirectUrl]);
      }
    });
  }

  signOut() {
    const that = this;

    that.af.signOut().then(function () {
      that.user.next(null);
      that.addressApi.removeBillingAddress();
      that.addressApi.removeDelivryAddress();
      that.myStripe.removeCurrCard();
    })
  }

  /**
   * @description Retourne un provider firebase via son nom
   * @param {string} providerName Nom du provider cible
   * @return {firebaseProvider}
   */
  getProvider(providerName: string): any {
    let parsedName: string | string[];
    providerName.search('.') !== 1 ? parsedName = providerName.split('.')[0] : parsedName = providerName;
    if (parsedName === 'facebook') {
      return this.facebookProvider;
    } else if (parsedName === 'twitter') {
      return this.twitterProvider;
    } else if (parsedName === 'google') {
      return this.googleProvider;
    }
  }

  /**
   * @description Supprime un compte utilisateur coté firebase
   * @return {void}
   */
  deleteFbUser(): void {

    const that = this;
    // that.af.auth.currentUser.delete();
    that.af.currentUser.then(function (user: any) {
      user.delete().then(function (val: any) {

      });
    })

  }


  /**
   * @description Crée un compte utilisateur coté base de donnée
   * @param {string} phone
   * @param {string} firstname
   * @param {string} lastname
   * @return {Promise}
   */
  createClient(phone?: any, countryId?: any, firstname?: any, lastname?: any, enable_marketing?: any, society?: any): Promise<any> {

    const that = this;

    return new Promise((resolve, reject) => {

      that.clientApi.createClientAccount(phone, countryId, firstname, lastname, enable_marketing, society).then(data => {

        if (data.code === 0) {

          resolve(null);

        } else {

          that.handleApiError(data.code);
          that.deleteFbUser();
          reject();

        }

      }).catch(err => {

        that.handleApiError(500)
        that.deleteFbUser();
        reject();

      });

    });
  }

  /**
   * @description Check si le password en parametre correspond au compte de l'utilisateur connecté
   * @param {string} providedPassword
   * @return {Promise}
   */
  checkPassword(providedPassword: string): Promise<any> {


    // const user = this.af.auth.currentUser;

    // const credential = firebase.auth.EmailAuthProvider.credential(user.email, providedPassword);
    // return new Promise((resolve, reject) => {
    //   user.reauthenticateAndRetrieveDataWithCredential(credential).then(function () {
    //     resolve(true);
    //   }).catch(function (error: any) {
    //     resolve(false);
    //   });
    // });




    return new Promise((resolve, reject) => {
      this.af.currentUser.then(function (user: any) {

        const credential = firebase.auth.EmailAuthProvider.credential(user.email, providedPassword);
        user.reauthenticateAndRetrieveDataWithCredential(credential).then(function () {

          resolve(true);
        }).catch(function (error: any) {
          resolve(false);
        });
      });
    })
  }


  /**
   * @description Modifie le mot de passe de l'utilisteur connecté
   * @param {string} newPassword
   * @return {Promise}
   */
  updatePassword(newPassword: string): Promise<any> {

    const that = this;
    // const user = this.af.auth.currentUser;

    // const user = firebase.auth().currentUser;


    // return new Promise(resolve => {

    //   user?.updatePassword(newPassword).then(function (data: any) {


    //     that.error.next("successpassword");
    //     resolve(null);

    //   }).catch(function (error: any) {

    //     if (error.code === "auth/requires-recent-login") {
    //       that.error.next("errneedlog");
    //     } else {
    //       that.handleApiError(500);
    //     }

    //     resolve(null);

    //   });

    // });

    return new Promise(resolve => {
      that.af.currentUser.then(function (user: any) {

        user.updatePassword(newPassword).then(function (data: any) {


          that.error.next("successpassword");
          resolve(null);

        }).catch(function (error: any) {

          if (error.code === "auth/requires-recent-login") {
            that.error.next("errneedlog");
          } else {
            that.handleApiError(500);
          }

          resolve(null);

        });

      });

    })
  }



  /**
  * @description Modifie l'adresse mail de l'utilisteur connecté
  * @param {string} newEmail
  * @return {Promise}
  */
  updateEmail(newEmail: string): Promise<any> {
    const that = this;
    that.error.next(null);


    // const user = firebase.auth().currentUser;
    // return new Promise((resolve) => {

    //   // that.af.auth.currentUser.updateEmail(newEmail).then(function () {

    //   user?.updateEmail(newEmail).then(function () {
    //     that.clientApi.updateClientAccount({ mail: newEmail }).then((data) => {
    //       resolve(data.updated_client);
    //     });

    //   }).catch(function (error: any) {

    //     if (error.code === "auth/requires-recent-login") {
    //       that.error.next("errneedlog");
    //     } else if (error.code === "auth/email-already-in-use") {
    //       that.error.next("erremailalreadyuse");
    //     } else {
    //       that.handleApiError(500);
    //     }

    //     resolve(null);

    //   });
    // });

    return new Promise((resolve) => {

      // that.af.auth.currentUser.updateEmail(newEmail).then(function () {
      that.af.currentUser.then(function (user: any) {
        user.updateEmail(newEmail).then(function () {
          that.clientApi.updateClientAccount({ mail: newEmail }).then((data) => {
            resolve(data.updated_client);
          });

        }).catch(function (error: any) {

          if (error.code === "auth/requires-recent-login") {
            that.error.next("errneedlog");
          } else if (error.code === "auth/email-already-in-use") {
            that.error.next("erremailalreadyuse");
          } else {
            that.handleApiError(500);
          }

          resolve(null);

        });
      });
    })
  }


  /**
  * @description Modifie le client
  * @param {string} account
  * @return {Promise}
  */
  updateclient(account: any, onSuccess: string): Promise<any> {


    const that = this;

    that.error.next(null);

    // const user = firebase.auth().currentUser;

    // return new Promise((resolve, reject) => {


    //   // that.af.auth.currentUser.updateEmail(account.mail).then(function (t: any) {
    //   user?.updateEmail(account.mail).then(function (t: any) {


    //     that.updateClient(account, onSuccess).then((data) => {

    //       resolve(data);
    //     });

    //   }).catch(function (error: any) {

    //     if (error.code === "auth/requires-recent-login") {
    //       that.error.next("errneedlog");
    //     } else if (error.code === "auth/email-already-in-use") {
    //       that.error.next("erremailalreadyuse");
    //     } else {
    //       that.handleApiError(500);
    //     }

    //     resolve(null);

    //   });
    // });



    return new Promise((resolve, reject) => {


      // that.af.auth.currentUser.updateEmail(account.mail).then(function (t: any) {
      that.af.currentUser.then(function (user: any) {
        user.updateEmail(account.mail).then(function (t: any) {


          that.updateClient(account, onSuccess).then((data) => {

            resolve(data);
          });

        }).catch(function (error: any) {

          if (error.code === "auth/requires-recent-login") {
            that.error.next("errneedlog");
          } else if (error.code === "auth/email-already-in-use") {
            that.error.next("erremailalreadyuse");
          } else {
            that.handleApiError(500);
          }

          resolve(null);

        });
      });
    })
  }


  /**
  * @description Met à jour le lastLogin
  * @return {Promise}
  */
  updateLastLogin(): Promise<any> {
    const params = { last_login: true };

    return this.clientApi.updateClientAccount(params);
  }


  /**
   * @deprecated N'est pas encore utilisée
   * @description Modifie les données firbase du compte utilisateur
   * @param {string} dataName
   * @param {string} dataValue
   * @return {Promise}
   */
  updateProfil(dataName: string, dataValue: string): Promise<any> {

    const that = this;
    let newObj: any;
    let successMessage: string;

    if (dataName === "username") {

      successMessage = "succnewusername";
      newObj = {
        displayName: dataValue
      }

    } else if (dataName === "profilpic") {

      successMessage = "succnewprofilpic";
      newObj = {
        photoURL: dataValue
      }

    }

    // return new Promise(resolve => {
    //   const user = firebase.auth().currentUser;
    //   // that.af.auth.currentUser.updateProfile(newObj).then(function () {
    //   user?.updateProfile(newObj).then(function () {


    //     that.error.next(successMessage);
    //     resolve(null);

    //   }).catch(function (error: any) {

    //     that.error.next("errHappen");
    //     resolve(null);

    //   });

    // });

    return new Promise(resolve => {
      that.af.currentUser.then(function (user: any) {
        user.updateProfile(newObj).then(function () {


          that.error.next(successMessage);
          resolve(null);

        }).catch(function (error: any) {

          that.error.next("errHappen");
          resolve(null);

        });
      })

    });
  }


  /**
   * @description Modifie le phone | lastname | firstname | birth du client connecté en fonction des parametres renseignés
   * @param {object} params Ex: {firstname: Lucas} | {phone: 06XXXXXXXX, id_country: 79} | {lastname: Rosinol} | {birth: XX-XX-XX}
   * @param {string} onSuccess Ex: "successfirstname" | "successlastname" | "successBirth" | "successPhone"
   * @return {Promise}
   */
  updateClient(params: any, onSuccess: string): Promise<any> {

    const that = this;

    return new Promise(resolve => {

      that.clientApi.updateClientAccount(params).then(data => {


        if (data.code === 0) {

          that.error.next(onSuccess);
          resolve(data.updated_client);

        } else {

          that.handleApiError(data.code)

        }

        resolve(null);

      });

    });

  }


  /**
    * @description delete le client

    */
  deleteClient(params: any): Promise<any> {

    const that = this;

    return new Promise(resolve => {

      that.clientApi.deleteClientAccount(params).then(data => {


        if (data.code === 0) {


          resolve("delete");

        } else {

          that.handleApiError(data.code)

        }

        resolve(null);

      });

    });

  }

  /**
  * @description Gère les erreurs api en fonction du code renseigné
  * @param {string|number} code
  * @return {void}
  */
  handleApiError(code: string | number): void {

    code = (typeof code === "string") ? parseInt(code) : code;
    const error = (code === -21) ? "erremailalreadyuse" : (code === -22) ? "errphonealreadytaken" : (code === -23) ? "errphoneinvalid" : (code === -25) ? "errnomobile" : "errHappen";
    this.error.next(error);
  }


}

